import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Drawer, Input } from 'antd';
import { DownloadOutlined, PlusOutlined, RedoOutlined } from '@ant-design/icons';
import { Box, Flex } from 'atoms';
import { useQueryParams } from 'hooks';
import { ACL, FilterTitle } from 'components/common';
import { ButtonWrapper, RCTable } from 'components';
// import { FilterAtnButton } from 'utils/commonStyled';
import { initialPaginateConfig } from 'utils';
import { getAirExpensesList } from 'store/airexpenseSlice';
import { AirExpensesTableConfig } from 'utils/table-config/AirExpensesTableConfig';
import { exportSlice } from 'store/pageSlice';

const { Search } = Input;
const LtSearchBar = styled(Search)`
	border: none;
`;

export default function AirExpenseList() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [rowData, setRowData] = useState({});
	const [open, setOpen] = useState(false);

	const [paginateConfig, setpaginateConfig] = useQueryParams({
		search_type: 'awb',
		persistKey: 'airExpenseList:filters',
	});

	const exportfunc = () => {
		const payload = {
			report_type: 'awb_csv_export',
			file_type: 'csv',
			data: {
				url_type: 'download',
				query_str: paginateConfig?.query_str,
			},
		};

		dispatch(exportSlice({ data: payload })).then((res) => {
			console.log('res', res);
		});
	};

	return (
		<>
			<Flex justifyContent="space-between" mt={3}>
				{/* <Box flex="0 0 35%">
					<SearchBar
						placeholder="Search"
						name="query_str"
						queryValue={paginateConfig?.query_str}
						onSearch={(val) =>
							setpaginateConfig({
								...paginateConfig,
								query_str: val,
							})
						}
					/>
				</Box> */}
				<Box flex="0 0 20%" marginRight="10px">
					<LtSearchBar
						placeholder="Search"
						enterButton="Search"
						allowClear
						onSearch={(val) =>
							setpaginateConfig({
								...paginateConfig,
								query_str: val,
							})
						}
					/>
				</Box>
				{/* <Box flex="0 0 35%" className="filter-hightlight">
					<Box flex="0 0 35%" display="flex">
						<FilterAtnButton
							onClick={() => {
								setOpen(true);
							}}
						>
							FILTERS
						</FilterAtnButton>
					</Box>
				</Box> */}
				<Flex>
					<ACL action="create" module="awb">
						<ButtonWrapper
							onClick={() => navigate('/airexpenses/air-bulk-upload')}
							icons={<PlusOutlined />}
						>
							BULK UPLOAD
						</ButtonWrapper>
					</ACL>
					<ButtonWrapper onClick={exportfunc} icons={<DownloadOutlined />}>
						EXPORT
					</ButtonWrapper>
					<ButtonWrapper
						onClick={() =>
							setpaginateConfig({
								...initialPaginateConfig,
								search_type: 'awb',
							})
						}
						icons={<RedoOutlined />}
					>
						SYNC
					</ButtonWrapper>
				</Flex>
			</Flex>
			<Box mt={3}>
				<RCTable
					rowKey="id"
					tableDatas={[rowData, setRowData]}
					togglePaginate={[paginateConfig, setpaginateConfig]}
					dispatchAction={getAirExpensesList}
					columns={AirExpensesTableConfig}
				/>
			</Box>

			<Drawer
				className="userList-drawer"
				title={<FilterTitle onClose={() => setOpen(false)} />}
				placement="right"
				closable={false}
				onClose={() => setOpen(false)}
				open={open}
			>
				<Box>
					<Box>
						<ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() => {
								window.location = `${window.origin}/trip-history`;
							}}
						>
							RESET FILTERS
						</ButtonWrapper>
					</Box>
				</Box>
			</Drawer>
		</>
	);
}
